export default "__VITE_ASSET__CsRL5iQJ__"